/***
 *
 *   HEADER
 *   Header section with title used in main application (can render children)
 *
 *   PROPS
 *   title: title of the view
 *   children: children to render (optional)
 *
 **********/
// import HeaderIcon from '../../assets/icons/Logo-Main_1.svg';
import Style from './header.module.scss';
import { useNavigate, NavLink } from 'react-router-dom';
import axios from 'axios';
import MenuIcon from '@mui/icons-material/Menu';
import { Icon, Logo, ViewContext } from 'components/lib';
import Drawer from '@mui/material/Drawer';
// import LogoImg from 'assets/icons/Logo-Main_3.svg';
import FeatherIcon from 'feather-icons-react';
import { useState } from 'react';
import { useContext } from 'react';


export function Header({ showNav = true, ...props }) {
	const navigate = useNavigate();
	const viewContext = useContext(ViewContext)
	const currentPath = window.location.pathname;
	// Check if the current path contains "terminal"
	const isTerminalPath =
		currentPath.includes('terminal') ||
		currentPath.includes('linux_advanced') ||
		currentPath.includes('deploy') ||
		currentPath.includes('jenkins') ||
		 currentPath.includes('security') ||
		currentPath.includes('pandas') ||
		currentPath.includes('statistics');
	let nodeId;
	const [showSideBar, setShowSideBar] = useState(false)

	if (isTerminalPath) {
		// Split the path into an array, find the index of 'nodes' and then get nodeId
		const pathParts = currentPath.split('/');
		const nodesIndex = pathParts.indexOf('nodes');
		nodeId = nodesIndex !== -1 ? pathParts[nodesIndex + 1] : null;
	}

	const handleClick = () => {
		if (isTerminalPath) {
			const formData = {
				node_id: nodeId,
			};
			const options = {
				method: 'DELETE',
				url: `/api/container-instances`,
				headers: {
					accept: 'application/json',
				},
				data: formData,
			};

			axios
				.request(options)
				.then(async function (response) {
				})
				.catch((err) => {
					console.log(err)
					viewContext.notification.show('Failed to exit the course properly! Please reach out to support.')
				});
			navigate('/navigate');
		} else {
			// Handle other cases
			navigate('/navigate');
		}
	};

	function showSide() {
		setShowSideBar(!showSideBar)
	}

	return (
		<header className={Style.header}>
			<Drawer
				anchor='left'
				open={showSideBar}
				sx={{
					width: '100%',

				}}
			>
				<div className={Style.menu}>
					{/* <img src={LogoImg} alt="Logo" style={{ width: '120px', maxWidth: "65px", marginLeft: '-20px', marginTop: '-20px' }} /> */}
					<Logo
						color="short"
					/>
					<FeatherIcon
						style={{ position: 'absolute', top: "0.8em", right: "0.4em" }}
						color='black'
						icon='x'
						onClick={() => {
							setShowSideBar(!showSideBar)
						}}
					/>
					<div
						className={Style.navLinks}
					>
						{
							props?.sideBarItems?.map(item => {
								if (item.link) {
									return (
										<NavLink
											key={item.label}
											to={item.link}
										>
											<span className={Style.iconLabelCOntainer}>
												{item.icon &&
													<Icon

														image={item.icon}
														size={20}
														color='#000'
													/>
												}
												{
													item.label &&
													<span className={Style.label}>
														{item.label}
													</span>
												}
											</span>
										</NavLink>
									)
								}
								return null;
							})
						}
					</div>
				</div>
			</Drawer>
			<div className={Style.logo}>
				{showNav && <MenuIcon className={Style.hamburgerIcon} onClick={showSide} />}
				{/* <img
					src={HeaderIcon}
					onClick={handleClick}
					style={{ width: '170px', cursor: 'pointer' }}
					alt="headerIcon"
				/> */}
				<Logo
					onClick={handleClick}
				/>
			</div>
			{/* { props.title && <h1>{ props.title }</h1> } */}
			{props.children}
		</header>
	);
}
